<script setup lang="ts">
/**
 * One `role="option"`. `value` identifies it (a string key is simplest); listen to `@select` to act
 * on the pick. Highlighted by the arrow keys or the pointer, selected by Enter or a click.
 */
import type { ComboboxItemEmits, ComboboxItemProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import { ComboboxItem, useForwardPropsEmits } from "reka-ui"
import { cn } from "@/lib/utils"

const props = defineProps<ComboboxItemProps & { class?: HTMLAttributes["class"] }>()
const emits = defineEmits<ComboboxItemEmits>()

const delegatedProps = reactiveOmit(props, "class")

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <ComboboxItem
    v-bind="forwarded"
    :class="cn(
      'relative flex w-full cursor-pointer select-none items-center gap-2 px-3 py-2 text-left text-sm outline-none transition-colors data-[highlighted]:bg-accent-lighter data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:shrink-0',
      props.class,
    )"
  >
    <slot />
  </ComboboxItem>
</template>
